export default __webpack_public_path__ + "static/media/gorditas.dad23885.jpeg";